import {
    CDR_DIALER,
    HOT_ACCESS_LIST,
    ACCESS_LIST_DIALER,
    PRICE_DIALER,
    SET_VISIBLE_RECAPTCHA,
    SET_TRUNK_NUMBER_DIALER,
    SET_REQUEST_DATA_RECAPTCHA,
    SET_NUMBER_ALLOCATION_MODAL
} from "const";
import {
    TRUNK_LIST_API,
    TRUNK_LIST_SMS_API,
    CDR_LIST_DIALER_API,
    SMS_MDR_LIST_DIALER_API,
    ACCESS_LIST_ACCOUNT_PRICE_DIALER_API,
    SMS_ACCESS_LIST_ACCOUNT_PRICE_DIALER_API,
    HOT_DIALER_ACCESS_LIST_API,
    SMS_HOT_DIALER_ACCESS_LIST_API,
    RATECARD_LIST_ACCOUNT_DIALER,
    RATECARD_LIST_DEFAULT_DIALER,
    RATECARD_LIST_INCORPORATED_ACCOUNT_DIALER,
    RATECARD_LIST_INCORPORATED_DEFAULT_DIALER,
    RATECARD_LIST_OTP_ACCOUNT_DIALER,
    RATECARD_LIST_OTP_DEFAULT_DIALER,
    SMS_RATECARD_LIST_ACCOUNT_DIALER,
    SMS_RATECARD_LIST_DEFAULT_DIALER,
    SMS_RATECARD_LIST_INCORPORATED_ACCOUNT_DIALER,
    SMS_RATECARD_LIST_INCORPORATED_DEFAULT_DIALER
} from "const/apiMethods";
import { createAction } from "./defaults";


const setStatusAllocationModal = createAction(SET_NUMBER_ALLOCATION_MODAL);
const setVisibleRecaptcha = createAction(SET_VISIBLE_RECAPTCHA);
const setRequiestData = createAction(SET_REQUEST_DATA_RECAPTCHA);

const setAccessList = createAction("SET_ITEMS_" + ACCESS_LIST_DIALER);
const setTestCalls = createAction("SET_ITEMS_" + CDR_DIALER);
const setViewNumberTrunk = createAction(SET_TRUNK_NUMBER_DIALER);
const setHotAccesses = createAction("SET_ITEMS_" + HOT_ACCESS_LIST)
const setPriceList = createAction("SET_ITEMS_" + PRICE_DIALER);

const ratecardMethods = [
    RATECARD_LIST_ACCOUNT_DIALER,
    RATECARD_LIST_DEFAULT_DIALER,
    RATECARD_LIST_INCORPORATED_ACCOUNT_DIALER,
    RATECARD_LIST_INCORPORATED_DEFAULT_DIALER,
    RATECARD_LIST_OTP_ACCOUNT_DIALER,
    RATECARD_LIST_OTP_DEFAULT_DIALER,
    SMS_RATECARD_LIST_ACCOUNT_DIALER,
    SMS_RATECARD_LIST_DEFAULT_DIALER,
    SMS_RATECARD_LIST_INCORPORATED_ACCOUNT_DIALER,
    SMS_RATECARD_LIST_INCORPORATED_DEFAULT_DIALER
];

export const storeDataOnRecaptchaComplete = (method, response, params = {}) => (dispatch) => {
    const actions = {
        [ACCESS_LIST_ACCOUNT_PRICE_DIALER_API]: setAccessList,
        [SMS_ACCESS_LIST_ACCOUNT_PRICE_DIALER_API]: setAccessList,
        [CDR_LIST_DIALER_API]: setTestCalls,
        [SMS_MDR_LIST_DIALER_API]: setTestCalls,
        [TRUNK_LIST_API]: setViewNumberTrunk,
        [TRUNK_LIST_SMS_API]: setViewNumberTrunk,
        [HOT_DIALER_ACCESS_LIST_API]: setHotAccesses,
        [SMS_HOT_DIALER_ACCESS_LIST_API]: setHotAccesses

    };

    const isRatecardMethod = ratecardMethods.includes(method);
    const action = actions[method] || (isRatecardMethod ? setPriceList : null);

    if (!action) {
        return;
    }

    let normalizedResponse = method === SMS_MDR_LIST_DIALER_API
        ? {
            ...response,
            cdr_full_list: response?.mdr_full_list || [],
            cdr_full_count: response?.mdr_full_count || 0,
            cdr_full_more: response?.mdr_full_more,
            cdr_full_summaries: response?.mdr_full_summaries || {}
        }
        : response;

    if (isRatecardMethod) {
        normalizedResponse = {
            ...response,
            ratecard_list: response?.ratecard_otp_list
                || response?.ratecard_incorporated_list
                || response?.ratecard_standart_list
                || [],
            ratecard_count: response?.ratecard_otp_count
                ?? response?.ratecard_incorporated_count
                ?? response?.ratecard_standart_count
                ?? 0
        };
    }

    return dispatch(action({
        ...normalizedResponse,
        page: params.page || 1,
        ...(params.per_page !== undefined ? { per_page: params.per_page } : {})
    }))
};

export const openAllocationModal = () => (dispatch) => {
    dispatch(setStatusAllocationModal(true));
};

export const closeAllocationModal = () => (dispatch) => {
    dispatch(setStatusAllocationModal(false));
};

const getRecaptchaMethodPriority = (method) => {
    const mainPageMethods = [
        ACCESS_LIST_ACCOUNT_PRICE_DIALER_API,
        SMS_ACCESS_LIST_ACCOUNT_PRICE_DIALER_API,
        CDR_LIST_DIALER_API,
        SMS_MDR_LIST_DIALER_API,
        HOT_DIALER_ACCESS_LIST_API,
        SMS_HOT_DIALER_ACCESS_LIST_API,
        ...ratecardMethods
    ];

    if (mainPageMethods.includes(method)) return 2;
    if ([TRUNK_LIST_API, TRUNK_LIST_SMS_API].includes(method)) return 1;
    return 0;
};

export const setRequestData = (methodRecaptcha, paramsRecaptcha) => (dispatch, getState) => {
    const settings = getState?.()?.settings;

    // Several requests can receive the captcha response at the same time.
    // A page's main request (for example Hot Access List) must not be
    // overwritten by an auxiliary trunk-list request that finishes later.
    if (
        settings?.visibleRecaptcha
        && settings.methodRecaptcha
        && getRecaptchaMethodPriority(settings.methodRecaptcha) >= getRecaptchaMethodPriority(methodRecaptcha)
    ) {
        return;
    }

    dispatch(setRequiestData({ methodRecaptcha, paramsRecaptcha }));
};

export const onVisibleRecaptcha = () => (dispatch) => {
    dispatch(setVisibleRecaptcha(true));
};

export const onInvisibleRecaptcha = () => (dispatch) => {
    dispatch(setVisibleRecaptcha(false));
};
